import { Annulation } from '../../annulation/models/Annulation';
import { TypeAnn_DIVER_G2 } from '../../diversAttribution/models/TypeAnn_DIVER_G2';
import { TypeAnn_DIVER_G1 } from '../../diversInitial/models/TypeAnn_DIVER_G1';
import { Rectificatif } from '../../rectificatif/models/Rectificatif';
import { TypeAdresseCompleteObligatoire } from './TypeAdresseCompleteObligatoire';

export class DIVERS {

    attribution: TypeAnn_DIVER_G2;

    annulation: Annulation;

    initial: TypeAnn_DIVER_G1;

    organisme: TypeAdresseCompleteObligatoire;

    rectificatif: Rectificatif ;

    constructor() {
        this.organisme = new TypeAdresseCompleteObligatoire();
        this.attribution = new TypeAnn_DIVER_G2();
        this.annulation = new Annulation();
        this.rectificatif = new Rectificatif();
    }
}
